import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, StatusCodeActive } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, GetStatus } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import { useCallApi } from "api/apiHooks";
import { PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";

export default function Category(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    const { fetchCategoryList, fetchDeleteCategory } = useCallApi()

    const [categoryList, setCategoryList] = useState([])
    const [categoryName, setCategoryName] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            const res = await fetchCategoryList(categoryName, status, PageSize, newIndex)

            if (CheckResponse(res)) {
                const totalData = res?.data?.totalData ?? 0;
                const total = Math.max(1, Math.ceil(totalData / PageSize));

                setCategoryList(res)
                setTotalPages(total);
                setPageIndex(newIndex);
            } else {
                openModal(ModalTypeFail, { message: res.message })
                return
            }
        } finally {
            closeModal();
        }
    }

    // Button Event
    const addBtnClick = () => {
        navigate("/category/form?categoryId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/category/form?categoryId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                fetchDeleteCategory(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        handlePageChange(pageIndex)
                        closeModal()
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            },
        })
    }

    useEffect(() => {
        if (firstLoad) {
            openModal(ModalTypeLoading)
        }

        handlePageChange(0).then(() => {
            setFirstLaod(false)
        })  
    },[categoryName, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Category' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Category Name</span>
                        <input className="input" value={categoryName} onChange={(e) => { setCategoryName(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Category Name</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { categoryList?.data?.listData?.length === 0 && (
                            <tr className="text-center h-12">
                               <td colSpan={8}>No Data Available</td> 
                            </tr>
                        )}
                        { categoryList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.categoryName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button gap-2 flex" onClick={() => editBtnClick(data.categoryId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.categoryId, data.status)}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}